<template>
  <!-- <div style="width:100%;height:60px;display: flex;align-items: center;justify-content: center;padding:0">
		<img src="../assets/logo.png" /> -->
  <div class="navMenu">

    <template v-for="navMenu in navMenus">
      <!-- 最后一级菜单 -->

      <el-menu-item v-if="!navMenu.children && navMenu.hidden" :key="navMenu.id" :data="navMenu" :index="navMenu.name">
        <div>
          <!-- <i :class="navMenu.meta.icon"></i> -->
          <span slot="title">{{navMenu.meta.title}}</span>
        </div>
      </el-menu-item>

      <el-submenu v-if="navMenu.children&& navMenu.hidden" :key="navMenu.id" :data="navMenu" :index="navMenu.name">
        <template slot="title">
          <!-- 	<i :class="navMenu.meta.icon"></i> -->
          <span> {{navMenu.meta.title}}</span>

        </template>
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>


      <!-- <el-menu-item   v-if="!navMenu.childs" :key="navMenu.entity.id" :data="navMenu.entity.name" :index="navMenu.entity.name" name="navMenu.entity.name" >


							<span slot="title">{{navMenu.entity.alias}}</span>

					</el-menu-item>


					<el-submenu v-if="navMenu.childs&&navMenu.entity" :key="navMenu.entity.id" :data="navMenu" :index="navMenu.entity.name" >
						<template slot="title">

							<span> {{navMenu.entity.alias}}</span>
						</template>

						<NavMenu :navMenus="navMenu.childs"></NavMenu>
					</el-submenu> -->
    </template>

    <!-- <div style="float: left;">
				<template v-for="navMenu in navMenus">


					<el-menu-item v-if="!navMenu.childs" :key="navMenu.entity.id" :data="navMenu" :index="navMenu.entity.name">

							<img src="../assets/sy2.jpg" style="width: 290px; height: 250px;margin-top: -50px;"/>

					</el-menu-item>


					<el-submenu v-if="navMenu.childs&&navMenu.entity" :key="navMenu.entity.id" :data="navMenu" :index="navMenu.entity.name">


					</el-submenu>
				</template>
			</div> -->
  </div>

  <!-- </div> -->
</template>

<script>
  export default {
    name: 'NavMenu',
    props: ['navMenus'],
    data() {
      return {}
    },
    methods: {},
    created: function() {
      // 	  debugger
      // 	  console.log("navMenus" + JSON.stringify(this.navMenus))
      //

    }
  }
</script>

<style scoped>
  * {
    outline: none;
  }
</style>
<style>
  .el-menu-item.is-active {
    border-bottom-color: rgb(255, 121, 117) !important;
  }

  .el-menu-item.is-active span {
    color: rgb(255, 121, 117) !important;
  }

  .el-menu--horizontal .el-menu .el-menu-item,
  .el-menu--horizontal .el-menu {
    line-height: 36px !important;
  }

  .el-menu-item,
  .el-submenu__title {
    line-height: 60px !important;
  }

  .el-submenu.is-active .el-submenu__title {
    border-bottom-color: rgb(255, 121, 117) !important;
    color: rgb(255, 121, 117) !important;
  }

  /* .el-submenu .is-active .el-submenu__title{

   } */
  /* .el-submenu .is-active span {

  } */
</style>



// WEBPACK FOOTER //
// src/components/Header.vue